import { ItemStatus } from "../types/DB2";

export function getScrollParent(node: any) {
  if (node == null) {
    return null;
  }

  if (node.scrollHeight > node.clientHeight) {
    return node;
  } else {
    return getScrollParent(node.parentNode);
  }
}
export function scrollToSection(sectionIndexToScrollTo: number, elm: any) {
  const LandingPageSections = document.querySelectorAll(
    ".landing-page-section-wrapper",
  );
  const SectionToScrollTo = LandingPageSections[sectionIndexToScrollTo];
  if (!SectionToScrollTo) return;
  const homepageElm = document.getElementsByClassName("desktop-homepage")[0];
  homepageElm.scrollTo({
    top: (SectionToScrollTo as any).offsetTop + 100,
    behavior: "smooth",
  });
}

export function isMobileDevice() {
  const hasTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;
  const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;
  const isMobileUserAgent =
    /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );

  return (hasTouch && isSmallScreen) || isMobileUserAgent;
}

export function getSuccessStatuses(
  unloadStatus: "loading" | "unloading",
): ItemStatus[] {
  if (!unloadStatus) return [];
  return (
    ({
      loading: ["in transit"],
      unloading: ["delivered"],
    }[unloadStatus] as ItemStatus[]) || []
  );
}

export function getStartingStatuses(
  unloadStatus: "loading" | "unloading",
): ItemStatus[] {
  if (!unloadStatus) return [];
  return (
    ({
      loading: ["pending"],
      unloading: ["in transit"],
    }[unloadStatus] as ItemStatus[]) || []
  );
}
